import { Encounter } from '@medplum/fhirtypes';
import { MedplumClient } from '@medplum/core';
import { useGenericResourceSearch } from '@/hooks/useGenericResourceSearch';
import {
  ENCOUNTER_SEARCH_DEFAULTS,
  encounterSearchConfig,
  type EncounterSearchParams,
} from './encounterSearchConfig';

export type { EncounterSearchParams };
export { ENCOUNTER_SEARCH_DEFAULTS };

export function useEncounterSearch(medplum: MedplumClient, patientId?: string) {
  return useGenericResourceSearch<EncounterSearchParams, Encounter>(
    medplum,
    encounterSearchConfig,
    patientId
  );
}
